import bButton from './b-button'

bButton.install = function (Vue) {
  Vue.component(bButton.name, bButton)
}

export default bButton
